module.exports = __webpack_public_path__ + "img/vertical_7_3_8004.4a8a5ef7.png";